export default __webpack_public_path__ + "static/reviews-graphics-right-5be159845f824f144a6a69029e080143.svg";